// import { Collection } from 'mongodb'
import { es, enUS } from 'date-fns/locale'
import { useTranslation } from 'react-i18next'
import { DatePicker } from '@mui/x-date-pickers/DatePicker'
import { Autocomplete, MenuItem, TextField } from '@mui/material'
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFnsV3'
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider'
import { Dispatch, SetStateAction, SyntheticEvent, useEffect, useState } from 'react'

import { /*Customer, */ FormError, Payment } from '../../types'
import { textFieldWhiteBg } from '../../theme/custom-styles'

export const CustomerCompanyPaymentsFilter = ({
  errors,
  setToDateToSearch,
  // customersCollection,
  setFromDateToSearch,
  // beneficiaryToSearch,
  // setBeneficiaryToSearch,
  handleModalLoadingState,
  customerCompanyPaymentsData
}: // customerCompanyBeneficiaries,
// customerCompanySuperAdminId,
// handleSetCustomerCompanyBeneficiaries
{
  errors: FormError
  // beneficiaryToSearch: string
  // customerCompanySuperAdminId: string
  // customersCollection: Collection | null
  // customerCompanyBeneficiaries: Array<Customer>
  customerCompanyPaymentsData: Array<Partial<Payment>>
  // setBeneficiaryToSearch: Dispatch<SetStateAction<string>>
  setToDateToSearch: Dispatch<SetStateAction<Date | null>>
  setFromDateToSearch: Dispatch<SetStateAction<Date | null>>
  handleModalLoadingState: (loadingStateToSet: boolean) => void
  // handleSetCustomerCompanyBeneficiaries: (customerCompanyBeneficiariesToSet: Array<Customer>) => void
}) => {
  const { t, i18n } = useTranslation(['customer-company-details-management', 'reports-management'])

  const [inputValue, setInputValue] = useState<string>('')
  const [selectedStatus, setSelectedStatus] = useState('')
  const [filteredOptions, setFilteredOptions] = useState<Array<{ customerId?: string; customerRegisteredFullName?: string }>>([])
  const [customerCompanyBeneficiariesList, setCustomerCompanyBeneficiariesList] = useState<Array<{ customerId?: string; customerRegisteredFullName?: string }>>([])

  /* useEffect(() => {
    if (customersCollection && customerCompanySuperAdminId) {
      handleGetCustomerCompanyBeneficiaries()
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [customersCollection, customerCompanySuperAdminId]) */

  useEffect(() => {
    if (Array.isArray(customerCompanyPaymentsData) && customerCompanyPaymentsData.length > 0) {
      setTimeout(() => handleGetCustomerCompanyBeneficiaries(), 100)
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [customerCompanyPaymentsData])

  const handleGetCustomerCompanyBeneficiaries = async () => {
    const customerCompanyPaymentsDataUniqueByCustomerId = handleRemoveDuplicates(customerCompanyPaymentsData, 'customerId')
    const customerCompanyPaymentsDataUniqueByCustomerName = handleRemoveDuplicates(customerCompanyPaymentsDataUniqueByCustomerId, 'customerRegisteredFullName')

    const customerCompanyBeneficiariesListToSet = customerCompanyPaymentsDataUniqueByCustomerName.map((companyPaymentsData) => {
      return {
        customerId: companyPaymentsData.customerId,
        customerRegisteredFullName: companyPaymentsData.customerRegisteredFullName
      }
    })

    setFilteredOptions(customerCompanyBeneficiariesListToSet)
    setCustomerCompanyBeneficiariesList(customerCompanyBeneficiariesListToSet)
    handleModalLoadingState(false)

    /* if (Array.isArray(customerCompanyBeneficiaries) && customerCompanyBeneficiaries.length === 0) {
      const customerCompanyBeneficiariesToSet = (await customersCollection?.find({ deleted: false, belongsTo: customerCompanySuperAdminId })) as unknown as Array<Customer>
      customerCompanyBeneficiariesToSet.sort((thisCustomer: Partial<Customer>, nextCustomer: Partial<Customer>) =>
        (thisCustomer?.registeredFullName || '').toLowerCase().localeCompare((nextCustomer?.registeredFullName || '').toLowerCase())
      )

      handleSetCustomerCompanyBeneficiaries(customerCompanyBeneficiariesToSet)
      setCustomerCompanyBeneficiariesList(customerCompanyBeneficiariesToSet)
    } else {
      customerCompanyBeneficiaries.sort((thisCustomer: Partial<Customer>, nextCustomer: Partial<Customer>) =>
        (thisCustomer?.registeredFullName || '').toLowerCase().localeCompare((nextCustomer?.registeredFullName || '').toLowerCase())
      )
      setCustomerCompanyBeneficiariesList(customerCompanyBeneficiaries)
    } */
  }

  const handleRemoveDuplicates = (array: Array<any>, attribute: string) => {
    return array.filter((item, index, self) => index === self.findIndex((obj) => obj[attribute] === item[attribute]))
  }

  const handleInputChange = (_: SyntheticEvent<Element, Event>, value: string) => {
    setInputValue(value)

    // Filter customers based on input
    const normalizedValue = value.toLowerCase()
    const matches = customerCompanyBeneficiariesList.filter((customer) => {
      const fullName = customer.customerRegisteredFullName?.toLowerCase() || ''
      const searchWords = normalizedValue.split(/\s+/)

      return searchWords.every((word) => fullName.includes(word))
    })
    setFilteredOptions(matches)
  }

  return (
    <div className="customer-company-payments-filter-container">
      <div className="payments-filter-row">
        <div className="filter-component">
          <LocalizationProvider
            dateAdapter={AdapterDateFns}
            adapterLocale={i18n && i18n.language.indexOf('es') !== -1 ? es : enUS}
          >
            <DatePicker
              label={t('filtersTexts.fromDate')}
              sx={{ width: '100%' }}
              onChange={(newValue) => setFromDateToSearch(newValue)}
              slotProps={{
                textField: {
                  fullWidth: true,
                  variant: 'standard',
                  error: !!errors.fromDateToSearch,
                  helperText: errors.fromDateToSearch,
                  sx: { ...textFieldWhiteBg, '& .MuiInputBase-root .MuiSelect-select': { height: '2.7em', boxSizing: 'border-box', padding: '12px 16px 4px', textAlign: 'start' } }
                }
              }}
            />
          </LocalizationProvider>
        </div>
        <div className="filter-component">
          <LocalizationProvider
            dateAdapter={AdapterDateFns}
            adapterLocale={i18n && i18n.language.indexOf('es') !== -1 ? es : enUS}
          >
            <DatePicker
              label={t('filtersTexts.toDate')}
              sx={{ width: '100%' }}
              onChange={(newValue) => setToDateToSearch(newValue)}
              slotProps={{
                textField: {
                  fullWidth: true,
                  variant: 'standard',
                  error: !!errors.toDateToSearch,
                  helperText: errors.toDateToSearch,
                  sx: { ...textFieldWhiteBg, '& .MuiInputBase-root .MuiSelect-select': { height: '2.7em', boxSizing: 'border-box', padding: '12px 16px 4px', textAlign: 'start' } }
                }
              }}
            />
          </LocalizationProvider>
        </div>
      </div>
      <div className="payments-filter-row">
        <div className="filter-component">
          <Autocomplete
            fullWidth
            inputValue={inputValue}
            onInputChange={handleInputChange}
            id="controllable-states-demo"
            options={filteredOptions}
            getOptionLabel={(option) => String(option.customerRegisteredFullName?.toUpperCase())}
            renderInput={(params) => (
              <TextField
                {...params}
                fullWidth
                variant="standard"
                label={t('filtersTexts.searchByBeneficiary')}
                sx={{ ...textFieldWhiteBg, '& .MuiInputBase-root .MuiSelect-select': { boxSizing: 'border-box' } }}
              />
            )}
            renderOption={(props, option) => (
              <li
                {...props}
                key={option.customerId}
              >
                {option.customerRegisteredFullName?.toUpperCase()}
              </li>
            )}
          />
          {/* <TextField
            select
            fullWidth
            variant="standard"
            label={t('filtersTexts.searchByBeneficiary')}
            value={beneficiaryToSearch ?? ''}
            sx={{ ...textFieldWhiteBg, '& .MuiInputBase-root .MuiSelect-select': { height: '2.7em', boxSizing: 'border-box', padding: '12px 16px 4px' } }}
            onChange={(event) => setBeneficiaryToSearch(event.target.value)}
          >
            <MenuItem
              disabled
              value=""
            >
              {t('filtersTexts.select')}
            </MenuItem>
            {customerCompanyBeneficiariesList.map((beneficiaryData: Customer, index: number) => {
              return (
                <MenuItem
                  key={index}
                  value={`${String(beneficiaryData._id)}-${beneficiaryData.registeredFullName}`}
                >
                  {beneficiaryData.registeredFullName}
                </MenuItem>
              )
            })}
          </TextField> */}
        </div>
      </div>
      <div className="payments-filter-row">
        <div className="filter-component">
          <div>
            <TextField
              select
              fullWidth
              label={t('modals.paymentsHistory.options.status', { ns: 'reports-management' })}
              variant="standard"
              /* error={!!errors?.selectedBankAccount}
                  label={t('paymentForm.accountToSend')}
                  helperText={errors?.selectedBankAccount} */
              value={selectedStatus ? selectedStatus : ''}
              onChange={(event) => setSelectedStatus(event.target.value)}
              sx={{ ...textFieldWhiteBg, '& .MuiInputBase-root .MuiSelect-select': { boxSizing: 'border-box', textAlign: 'start' } }}
            >
              <MenuItem value="processing">{t('modals.paymentsHistory.options.statuses.processing', { ns: 'reports-management' })}</MenuItem>
              <MenuItem value="validated">{t('modals.paymentsHistory.options.statuses.validated', { ns: 'reports-management' })}</MenuItem>
              <MenuItem value="paid">{t('modals.paymentsHistory.options.statuses.paid', { ns: 'reports-management' })}</MenuItem>
              <MenuItem value="rejected">{t('modals.paymentsHistory.options.statuses.rejected', { ns: 'reports-management' })}</MenuItem>
              <MenuItem value="returned">{t('modals.paymentsHistory.options.statuses.returned', { ns: 'reports-management' })}</MenuItem>
            </TextField>
          </div>
        </div>
      </div>
    </div>
  )
}
